module.exports = __webpack_public_path__ + "static/media/free-shipping-icon.695f8e03.png";